import { Routes as ConstantRoutes } from 'constants/global'
import React, { FC, PropsWithChildren } from 'react'
import { Navigate } from 'react-router-dom'
import { ROLES } from 'prace-common-components'
import { RootState } from 'store'
import { useAppSelector } from 'store/hooks'

export const PrivateRoute: FC<PropsWithChildren<{ deny?: ROLES[] }>> = ({ children, deny }) => {
  const isAuth = useAppSelector((state: RootState) => state.auth.isAuth)
  const user = useAppSelector((state: RootState) => state.auth.user)
  if (!isAuth || !user) return <Navigate to={ConstantRoutes.LOGIN} />
  /* The admin portal logs out on any 403, so send denied roles home before the page calls the API */
  if (deny?.includes(user.role)) return <Navigate to={ConstantRoutes.HOME} replace />
  return children
}
